<template>
  <v-row>
    <v-col cols="12">
      <piriod-view-loader v-if="$store.state.subscriptions.retrieveLoader" view-type="retrieve" />
      <v-card v-else>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{name: 'ProductRetrieveUpdate', params: {id: $route.query.product}}" class="subtitle-1 routerLink font-weight-medium">{{productsDetail.name}}</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            <span class="subtitle-1 font-weight-medium">Nuevo plan de precios</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-0 background" style="height: calc(100vh - 225px); overflow-y: auto;">
          <v-row class="fill-height">
            <v-col md="8" class="fill-height overflow-y-auto">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>
                    <span class="text--secondary font-weight-medium">Modelo de precios</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>

              <v-sheet class="mt-2 mb-6 px-4 v-sheet--option-selection" color="transparent">
                <template >
                  <v-card class="pa-3" @click="selectedPricingScheme = d.id" v-for="d in pricingSchemes" :class="{ 'active': selectedPricingScheme === d.id }" :key="`v-card--${d.id}`" outlined rounded :ripple="false">
                    <v-card-title class="pa-0">
                      <v-icon small :color="(selectedPricingScheme === d.id ? 'primary' : 'secondary')">mdi-poll</v-icon>
                      <v-spacer />
                      <v-tooltip color="primary" dark max-width="280" top transition="scale-transition">
                        <template v-slot:activator="{on}">
                          <v-icon v-on="on" color="blue-grey lighten-1" small>mdi-information</v-icon>
                        </template>
                        <span class="white--text">{{d.description}}</span>
                      </v-tooltip>
                    </v-card-title>
                    <span class="mt-3 caption d-block text--secondary font-weight-medium">{{d.name}}</span>
                  </v-card>
                </template>
              </v-sheet>

              <!-- {{ plan }} -->

              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="px-1">
                    <span class="body-2 text--secondary font-weight-medium">Precio</span>
                  </v-list-item-title>
                </v-list-item>

                <!-- flat pricing -->
                <template v-if="selectedPricingScheme === 'flat'">
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" class="py-1 d-flex align-center">
                        <div style="width:145px">
                          <v-text-field id="it-plan-amount" v-model.number="$v.plan.amount.$model" :error="$v.plan.amount.$error" :suffix="plan.currency" hint="Escribe un precio" persistent-hint :hide-details="!$v.plan.amount.$error" background-color="white" outlined required single-line dense placeholder="0.00" />
                        </div>
                        <div style="width:260px">
                          <v-select v-model.trim="$v.plan.currency.$model" :items="currencies" item-value="id" item-text="name" label="Elige una moneda" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                            <template v-slot:item="data">
                              <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                            </template>
                          </v-select>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
                <!-- end flat pricing -->

                <!-- tiered pricing -->
                <template v-else>
                  <v-list-item>
                    <v-list-item-subtitle>
                      <v-col cols="4" class="pa-0">
                        <v-select v-model.trim="$v.plan.currency.$model" :items="currencies" item-value="id" item-text="name" label="Elige una moneda" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                          <template v-slot:item="data">
                            <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                          </template>
                        </v-select>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="d-block">
                    <v-row>
                      <v-col cols="12" class="pb-0 d-flex align-center">
                        <span class="ml-1 text--secondary font-weight-medium" style="width:345px">Unidades</span>
                        <span class="ml-1 text--secondary font-weight-medium">Precio</span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="py-1 d-flex align-center" v-for="(f, i) in plan.tiers" :key="i">
                        <!-- units -->
                        <template v-if="i !== (plan.tiers.length - 1)">
                          <div style="width:125px">
                            <v-text-field class="pa-0" background-color="white" dense disabled hide-details outlined readonly reverse single-line :value="plan.tiers[i].quantity_from">
                              <template v-slot:append>
                                <span class="px-2 py-1 text--primary font-weight-medium">
                                  <template v-if="['volume', 'graduated'].includes(plan.tiers_mode)">de</template>
                                  <template v-else-if="['package', 'package_overage'].includes(plan.tiers_mode)">entre</template>
                                </span>
                              </template>
                            </v-text-field>
                          </div>
                          <div style="width:125px">
                            <v-tooltip :disabled="!$v.plan.tiers.$each[i].quantity_to.$error" max-width="280" right transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" v-on="on" v-model.number="plan.tiers[i].quantity_to" class="pa-0" background-color="white" dense :error="$v.plan.tiers.$each[i].quantity_to.$error" hide-details :keyup="setNextTier(i)" outlined persistent-hint required reverse single-line>
                                  <template v-slot:append>
                                    <span class="px-2 py-1 text--primary font-weight-medium">
                                      <template v-if="['volume', 'graduated'].includes(plan.tiers_mode)">hasta</template>
                                      <template v-else-if="['package', 'package_overage'].includes(plan.tiers_mode)">y</template>
                                    </span>
                                  </template>
                                </v-text-field>
                              </template>
                              <span class="red--text">La cantidad se superpone con el nivel anterior, debe ser mayor que {{ (plan.tiers[i].quantity_from) }}</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-else>
                          <div style="width:250px">
                            <v-text-field class="pa-0" background-color="white" dense disabled hide-details readonly reverse outlined single-line :value="(plan.tiers[i].quantity_from - 1)">
                              <template v-slot:append>
                                <span class="pl-2 py-1 text--primary font-weight-medium">más de</span>
                              </template>
                            </v-text-field>
                          </div>
                        </template>
                        <!-- end units -->

                        <span class="ml-2 mr-8 text-secondary font-weight-medium">unidades</span>

                        <!-- amount -->
                        <div style="width:140px">
                          <v-tooltip :disabled="!$v.plan.tiers.$each[i].amount.$error" max-width="280" right transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-bind="attrs" v-on="on" v-model.number="plan.tiers[i].amount" class="ma-1 ml-0" background-color="white" dense hide-details :error="$v.plan.tiers.$each[i].amount.$error" outlined persistent-hint placeholder="0.00" required single-line :suffix="plan.currency" />
                            </template>
                            <span class="red--text">El precio es requerido</span>
                          </v-tooltip>
                        </div>

                        <span class="ml-2 text-secondary font-weight-medium" v-if="f.unit_scheme">
                          <template v-if="(['all_units', 'overage']).includes(f.unit_scheme)">cada unidad</template>
                          <template v-else-if="f.unit_scheme === 'tier_units'">cada unidad del tramo</template>
                        </span>
                        <!-- end amount -->

                        <div class="mx-2" style="width:34px">
                          <template v-if="i >= 1 && (i === plan.tiers.length - 2)">
                            <v-btn @click="removeRowTiers(i)" color="primary" icon medium><v-icon>mdi-trash-can</v-icon></v-btn>
                          </template>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="ml-3">
                        <v-btn @click.prevent="addTier" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar otro tramo</v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
                <!-- end tiered pricing -->

                <v-list-item class="my-3">
                  <v-list-item-title class="overflow-visible">
                    <v-switch v-model="plan.exempt" hide-details>
                      <template v-slot:label>
                        <span class="mx-1 text--secondary font-weight-medium">Precio exento de impuestos</span>
                      </template>
                    </v-switch>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="my-3">
                  <v-list-item-title class="overflow-visible">
                    <v-switch v-model="plan.usage_scheme" false-value="licensed" true-value="metered" hide-details>
                      <template v-slot:label>
                        <span class="mx-1 text--secondary font-weight-medium">Cobrar según el uso</span>
                        <v-tooltip color="primary" dark max-width="280" right transition="scale-transition">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                          </template>
                          <span class="white--text">La facturación por uso te permite cobrar de acuerdo a los registros de uso que se hayan informado al final de cada periodo de facturación.</span>
                        </v-tooltip>
                      </template>
                    </v-switch>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="pl-16" v-if="plan.usage_scheme === 'metered'">
                  <v-list-item-content class="overflow-visible">
                    <v-list-item-title class="pl-1">Esquema de cálculo</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8" class="pa-0">
                        <v-radio-group v-model="plan.usage_aggregation" :mandatory="false">
                          <v-radio v-for="aggregation in usageAggregationsList" :key="aggregation.value" :label="aggregation.label" :value="aggregation.value"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider class="mx-4 my-10" />

              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="px-1">
                      <span class="text--secondary font-weight-medium">Frecuencia de facturación</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col class="py-2 px-0 pb-0" cols="3">
                        <v-select v-model.trim="$v.plan.frequency.$model" :items="frequenciesList" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider class="mx-4 my-10" />

              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="px-1">
                    <span class="text--secondary font-weight-medium">Presentación del plan</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item >
                  <v-list-item-content>
                    <v-list-item-title class="px-1">
                      Nombre
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span>No será visible para los clientes, pero te ayudará a identificar este plan en tu cuenta.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="5" class="pa-0">
                        <v-text-field v-model.trim="$v.plan.name.$model" :error="$v.plan.name.$error" background-color="white" outlined required single-line dense  maxlength="35" hint="Nombre es requerido." persistent-hint :hide-details="!$v.plan.name.$error" placeholder="Mensual" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item >
                  <v-list-item-content>
                    <v-list-item-title class="px-1">Descripción</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="7" class="pa-0">
                        <v-text-field v-model="$v.plan.description.$model" :error="$v.plan.description.$error" background-color="white" outlined required single-line dense  maxlength="200" hint="Escribe una descripción" persistent-hint :hide-details="!$v.plan.description.$error" placeholder="Ej: Acceso mensual a ..." />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider class="mx-4 my-10" />

              <!-- more options -->
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="px-1">
                    <span class="text--secondary font-weight-medium">Otras opciones</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item >
                  <v-list-item-content>
                    <v-list-item-title class="px-1">Código</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="3" class="pa-0">
                        <v-text-field v-model.trim="$v.plan.sku.$model" :error="$v.plan.sku.$error" background-color="white" outlined required single-line dense maxlength="32" persistent-hint hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item >
                  <v-list-item-content>
                    <v-list-item-title class="px-1">Unidad</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="3" class="pa-0">
                        <v-text-field v-model.trim="$v.plan.unit_label.$model" :error="$v.plan.unit_label.$error" background-color="white" placeholder="Etiqueta de unidad" outlined required single-line dense maxlength="4" persistent-hint hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- end more options -->
              </v-list>
            </v-col>
            <v-divider vertical />
            <v-col class="fill-height overflow-y-auto white">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="text--secondary font-weight-medium">Previsualización</v-list-item-title>
                    <v-list-item-subtitle class="overflow-visible d-block caption text--primary">Estima el total según el modelo de precios y la cantidad.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">Cantidad de unidades</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col class="py-2 px-0 pb-0" cols="6">
                        <v-text-field v-model.number="previewQuantity" background-color="white" outlined required single-line dense persistent-hint hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider class="ma-4" />

              <v-list class="transparent">
                <template v-if="selectedPricingScheme !== 'flat'">
                  <v-list-item v-for="(b, i) in preview[1]" :key="i">
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">{{b.tierQuantity}} x {{b.tierAmount | currency(activeCurrency.id)}} {{activeCurrency.id}}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right text--primary">{{b.tierTotal | currency(activeCurrency.id)}} {{activeCurrency.id}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-divider class="ma-4" />
                </template>

                <v-list-item>
                  <v-list-item-title class="text--secondary font-weight-medium">Total</v-list-item-title>
                  <v-list-item-subtitle class="text-right text--primary">{{preview[0] | currency(activeCurrency.id)}} {{activeCurrency.id}} <template v-if="!plan.exempt">+ impuestos</template></v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer/>
          <v-btn id="it-plan-create" @click="createPlan" :loading="$store.state.subscriptions.createLoader" color="primary">Crear plan</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { decimal, maxLength, numeric, required, requiredIf } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    plan: {
      amount: null,
      currency: 'CLP',
      description: '',
      exempt: false,
      frequency: 'monthly',
      name: '',
      product: null,
      sku: null,
      tiers: [],
      tiers_mode: null,
      usage_scheme: 'licensed',
      usage_aggregation: 'sum',
      unit_label: null
    },
    planDetail: [
      { name: '', value: 'unit' },
      { name: '', value: 'range' }
    ],
    previewQuantity: 1,
    pricingSchemes: [
      {
        id: 'flat',
        name: 'Precio fijo',
        description: 'Cobra siempre el mismo monto al cliente, sin importar la cantidad de unidades.'
      },
      {
        id: 'volume',
        name: 'Por volumen',
        description: 'Cobra todas las unidades al cliente según el precio del tramo alcanzado.'
      },
      {
        id: 'graduated',
        name: 'Por volumen gradual',
        description: 'Cobra cada tramo con su propio precio y solo cobra las unidades dentro de ese tramo.'
      },
      {
        id: 'package',
        name: 'Por paquete',
        description: 'Cobra un monto fijo al cliente según el tramo de unidades alcanzado.'
      },
      {
        id: 'package_overage',
        name: 'Por paquete con excedente',
        description: 'Cobra un paquete base y el uso que exceda el límite cóbralo por unidad.'
      }
    ],
    selectedPricingScheme: 'flat',
    test: [],
    usageAggregationsList: [
      { value: 'sum', label: 'Suma de los registros de uso informados en el periodo' },
      { value: 'max', label: 'Máximo registro de uso informado en el periodo' },
      { value: 'last_record', label: 'Último registro de uso informado en el período' }
    ]
  }),
  computed: {
    preview () {
      /**
       * return list of totals according to selected pricing scheme and previewQuantity.
       * For case graduated, return the total of each tier in an array, to be able to show a breakdown of the total price by tier in the UI.
       * For case package_overage, return an array with two elements, the first one is the price of the package and the second one is the overage price, to be able to show a breakdown in the UI.
       */

      const scheme = this.selectedPricingScheme

      if (scheme === 'flat') {
        return [this.plan.amount * this.previewQuantity]
      }

      if (scheme === 'volume') {
        let tier = this.plan.tiers.find(t => t.quantity_to && t.quantity_from <= this.previewQuantity && t.quantity_to >= this.previewQuantity)

        if (!tier) {
          tier = this.plan.tiers.find((t, i) => i === this.plan.tiers.length - 1)
        }

        const total = tier.amount * this.previewQuantity

        const breakdown = [{
          tierAmount: tier.amount,
          tierQuantity: this.previewQuantity,
          tierTotal: total
        }]

        return [total, breakdown]
      }

      if (scheme === 'graduated') {
        let total = 0
        const breakdown = []

        for (const tier of this.plan.tiers) {
          const start = Math.max(1, tier.quantity_from)

          if (start > this.previewQuantity) {
            break
          }

          const end = Math.min(this.previewQuantity, tier.quantity_to ?? this.previewQuantity)

          if (end < start) {
            continue
          }

          const quantityInTier = end - start + 1
          const amountForTier = tier.amount_scheme === 'per_unit' ? quantityInTier * tier.amount : tier.amount

          breakdown.push({ tierAmount: tier.amount, tierQuantity: quantityInTier, tierTotal: amountForTier })
          total += amountForTier
        }

        return [total, breakdown]
      }

      if (scheme === 'package') {
        const q = Number(this.previewQuantity)

        let tier = this.plan.tiers.find(t =>
          t.quantity_to != null &&
          Number(t.quantity_from) <= q &&
          Number(t.quantity_to) >= q
        )

        if (!tier) {
          tier = this.plan.tiers[this.plan.tiers.length - 1]
        }

        const tierAmount = Number(tier.amount || 0)
        const breakdown = [{
          tierAmount,
          tierQuantity: 1,
          tierTotal: tierAmount
        }]

        return [tierAmount, breakdown]
      }

      if (scheme === 'package_overage') {
        const q = Number(this.previewQuantity)

        // 1) Tier base (package): el tramo "cerrado" que contenga q
        //    si q supera el máximo, usamos el último tramo cerrado (mayor quantity_to)
        let packageTier = this.plan.tiers
          .filter(t => t.quantity_to != null && t.unit_scheme !== 'overage')
          .find(t => Number(t.quantity_from) <= q && Number(t.quantity_to) >= q)

        if (!packageTier) {
          packageTier = this.plan.tiers
            .filter(t => t.quantity_to != null && t.unit_scheme !== 'overage')
            .sort((a, b) => Number(b.quantity_to) - Number(a.quantity_to))[0]
        }

        // 2) Tier de overage (por unidad)
        const overageTier = this.plan.tiers.find(t => t.unit_scheme === 'overage' || t.quantity_to == null)

        const packageAmount = Number(packageTier?.amount || 0)

        const baseMax = Number(packageTier?.quantity_to || 0)
        const overageQuantity = Math.max(0, q - baseMax)

        const overageUnitPrice = Number(overageTier?.amount || 0)
        const overageAmount = overageTier
          ? (overageTier.amount_scheme === 'per_unit'
              ? overageQuantity * overageUnitPrice
              : overageUnitPrice)
          : 0

        const breakdown = [
          { tierAmount: packageAmount, tierQuantity: 1, tierTotal: packageAmount, kind: 'package' },
          { tierAmount: overageUnitPrice, tierQuantity: overageQuantity, tierTotal: overageAmount, kind: 'overage' }
        ].filter(x => x.tierQuantity > 0)

        return [packageAmount + overageAmount, breakdown]
      }

      return [0, [{}]]
    },
    activeCurrency () {
      return this.currencies.find(c => c.id === this.plan.currency)
    },
    selectedPricingSchemeObject () {
      return this.pricingSchemes.find(p => p.id === this.selectedPricingScheme)
    },
    ...mapState({
      productsDetail: state => state.subscriptions.productsDetail,
      frequenciesList: state => state.subscriptions.frequenciesList
    })
  },
  created () {
    this.$store.dispatch('subscriptions/RETRIEVE', {
      resource: 'products',
      id: this.$route.query.product
    })
    .then(() => {
      this.plan.product = this.$route.query.product

      if (!this.$store.state.subscriptions.frequenciesList.length) {
        this.$store.dispatch('subscriptions/LIST', {
          resource: 'frequencies'
        })
      }
    })
  },
  watch: {
    selectedPricingScheme (selection) {
      if (selection === 'flat') {
        this.plan.tiers_mode = null
        return
      }

      // reset tiers validations
      if (this.plan.tiers.length) {
        this.$v.plan.tiers.$reset()
      }

      this.plan.tiers_mode = selection

      if (selection === 'volume') {
        this.plan.tiers = [
          {
            amount: null,
            amount_scheme: 'per_unit',
            quantity_from: 0,
            quantity_to: 1,
            unit_scheme: 'all_units'
          },
          {
            amount: null,
            amount_scheme: 'per_unit',
            quantity_from: 2,
            quantity_to: null,
            unit_scheme: 'all_units'
          }
        ]

        return
      }

      if (selection === 'graduated') {
        this.plan.tiers = [
          {
            amount: null,
            amount_scheme: 'per_unit',
            quantity_from: 0,
            quantity_to: 1,
            unit_scheme: 'tier_units'
          },
          {
            amount: null,
            amount_scheme: 'per_unit',
            quantity_from: 2,
            quantity_to: null,
            unit_scheme: 'tier_units'
          }
        ]

        return
      }

      if (selection === 'package') {
        this.plan.tiers = [
          {
            amount: null,
            amount_scheme: 'flat',
            quantity_from: 0,
            quantity_to: 1,
            unit_scheme: null
          },
          {
            amount: null,
            amount_scheme: 'flat',
            quantity_from: 2,
            quantity_to: null,
            unit_scheme: null
          }
        ]

        return
      }

      if (selection === 'package_overage') {
        this.plan.tiers = [
          {
            amount: null,
            amount_scheme: 'flat',
            quantity_from: 0,
            quantity_to: 1,
            unit_scheme: null
          },
          {
            amount: null,
            amount_scheme: 'per_unit',
            quantity_from: 2,
            quantity_to: null,
            unit_scheme: 'overage'
          }
        ]
      }
    }
  },
  methods: {
    createPlan () {
      if (this.selectedPricingScheme !== 'flat') {
        this.plan.amount = 0
      }

      this.$v.plan.$touch()

      if (this.$v.plan.$invalid) {
        return false
      }

      this.$store.dispatch('subscriptions/CREATE', {
        resource: 'plans',
        payload: this.plan
      })
      .then((response) => {
        this.$router.push({
          name: 'PlanRetrieveUpdate',
          params: {
            id: response.data.id
          }
        })
        this.$dialog.message.info('El plan ha sido creado')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    addTier () {
      /**
       * Add a new tier before the last one, which is the "catch all" tier with
       * quantity_to null. The new tier will take the quantity_from of the last
       * tier + 1, and the last tier will be updated to have that quantity_from + 1
       * as quantity_to. If the last tier doesn't have quantity_to, it means it's the
       * first tier being added, so we set quantity_from to 1.
       * The new tier will also take the amount_scheme and unit_scheme
       * according to the selected pricing scheme.
       */
      const lastTier = this.plan.tiers[this.plan.tiers.length - 1]
      const penultimateTier = this.plan.tiers[this.plan.tiers.length - 2]

      const newTier = {
        amount: null,
        amount_scheme: null,
        quantity_from: lastTier.quantity_to ? lastTier.quantity_to + 1 : null,
        quantity_to: penultimateTier.quantity_to ? penultimateTier.quantity_to + 2 : null,
        unit_scheme: null
      }

      const tierDefaults = {
        volume: {
          amount_scheme: 'per_unit',
          unit_scheme: 'all_units'
        },
        graduated: {
          amount_scheme: 'per_unit',
          unit_scheme: 'tier_units'
        },
        package: {
          amount_scheme: 'flat',
          unit_scheme: null
        },
        package_overage: {
          amount_scheme: 'flat',
          unit_scheme: null
        }
      }

      const defaults = tierDefaults[this.selectedPricingScheme]

      if (defaults) {
        Object.assign(newTier, defaults)
      }

      this.plan.tiers.splice((this.plan.tiers.length - 1), 0, newTier)
    },
    setNextTier (i) {
      this.plan.tiers[i + 1].quantity_from = this.plan.tiers[i].quantity_to + 1
    },
    removeRowTiers (i) {
      this.plan.tiers.splice(i, 1)
    }
  },
  validations: {
    plan: {
      amount: {
        required: requiredIf(function () {
          return this.selectedPricingScheme === 'flat'
        }),
        decimal
      },
      sku: {
        maxLength: maxLength(32)
      },
      currency: {
        required
      },
      description: {
        required,
        maxLength: maxLength(200)
      },
      frequency: {
        required
      },
      name: {
        required,
        maxLength: maxLength(56)
      },
      tiers: {
        $each: {
          amount: {
            required,
            decimal
          },
          quantity_from: {
            required,
            numeric
          },
          quantity_to: {
            numeric,
            required (value, tier) {
              const idx = tier?.$index

              if (typeof idx !== 'number') {
                return true
              }

              const isLast = idx === (this.plan.tiers.length - 1)

              if (isLast) {
                return true
              }

              return (value !== null && value !== undefined && value !== '')
            },
            gtQuantityFrom (value, tier) {
              if (value === null || value === undefined || value === '') {
                return true
              }

              const from = tier?.quantity_from

              if (from === null || from === undefined || from === '') {
                return true
              }

              return Number(value) > Number(from)
            }
          }
        }
      },
      tiers_mode: {
        required: requiredIf(function () {
          return this.selectedPricingScheme !== 'flat'
        })
      },
      unit_label: {
        maxLength: maxLength(4)
      }
    }
  }
}
</script>
<style>
.v-sheet--option-selection {
  display: flex;
  flex-direction: row !important;
  gap: 12px;
}

.v-sheet--option-selection > * {
  cursor: pointer;
  flex: 1 1 0;
  min-width: 0;
}

.v-sheet--option-selection > .active {
  border-color: #3F51B5;
  box-shadow: 0px 0px 0px 3px #CCE1FF;
}

.v-sheet--option-selection > .active:before {
  opacity: 0.08;
}
</style>